import { Outlet } from "react-router-dom";
import React from "react";

const BaseLayout = () => {
  return <Outlet />;
};

export default BaseLayout;
